import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { lastValueFrom, map } from 'rxjs';
import { CallType } from '../features/call/interfaces/CallType/CallType';
import { formatDate } from '../utils';
import { isNullUndefinedEmpty, momentCustomInstance as moment } from '../utils/helper';
import { Constants } from '@app/constants';
@Injectable({
  providedIn: 'root',
})
export class CallBackService {
  constructor(private httpClient: HttpClient, private authService: AuthenticationService) { }

  /**
   * getUserStatusStats
   * @param from  start date
   * @param to    end date
   * @param limit    data limit
   */
  getAgentRecentCalls(
    from: string,
    to: string,
    limit: Number,
    Skip: Number,
    fields: string,
    fieldValues: string,
    criteria: string
  ) {
    const url = `/calls/agentRecentCallbacks?StartDate=${from}&EndDate=${to}&Limit=${limit}&Skip=${Skip}&Fields=${fields}&FieldValues=${fieldValues}&Criteria=${criteria}`;
    return this.httpClient.get(url).pipe(
      map((data: any) => {
        return {
          totalCount: data.TotalCount,
          calls: data.RecentCallbacksByAgent.map((d: any) => {
            // var date = new Date(0);
            // date.setSeconds(d.Duration); // specify value for SECONDS here
            // var timeString = date.toISOString().substring(11, 19);

            return {
              full_name: isNullUndefinedEmpty(d.Name),
              call_Type: CallType[d.Direction],
              disposition: isNullUndefinedEmpty(d.Disposition),
              duration: formatDate(d.Duration),
              skill: d.skill,
              campaign: d.CampaignCode,
              tfn: d.TFN,
              ucid: d.CallSid,
              callbackNumber: d.CallbackNumber,
              createdOn: d.CreatedOn,
              call_campaign: {
                Id: d.CampaignId,
                Name: d.Campaign,
                Code: d.CampaignCode,
                LanguageCode: d.LanguageCode,
              },
            };
          }),
        };
      })
    );
  }

  /**
   * getAgentCallbacks
   * @param from  start date
   * @param to    end date
   * @param limit    data limit
   */
  getAgentCallbacks(
    from: string,
    to: string,
    limit: Number,
    Skip: Number,
    fields: string,
    fieldValues: string,
    criteria: string
  ) {
    const url = `/calls/agentCallbacks?StartDate=${from}&EndDate=${to}&Limit=${limit}&Skip=${Skip}&Fields=${fields}&FieldValues=${fieldValues}&Criteria=${criteria}`;
    return this.httpClient.get(url).pipe(
      map((data: any) => {
        return {
          totalCount: data.TotalCount,
          calls: data.RecentCallbacksByAgent.map((d: any) => {
            // var date = new Date(0);
            // date.setSeconds(d.Duration); // specify value for SECONDS here
            // var timeString = date.toISOString().substring(11, 19);

            return {
              full_name: isNullUndefinedEmpty(d.Name),
              call_Type: CallType[d.Direction],
              disposition: isNullUndefinedEmpty(d.Disposition),
              duration: formatDate(d.Duration),
              skill: d.skill,
              campaign: d.CampaignCode,
              tfn: d.TFN,
              ucid: d.CallSid,
              callbackNumber: d.CallbackNumber,
              createdOn: d.CreatedOn,
              call_campaign: {
                Id: d.CampaignId,
                Name: d.Campaign,
                Code: d.CampaignCode,
                LanguageCode: d.LanguageCode,
              },
              lead_id: d.LeadId,
              phoneNumber: d.ConfirmBTN,
              country_code: d.CountryCode,
            };
          }),
        };
      })
    );
  }

  /**
   * getUserStatusStats
   * @param from  start date
   * @param to    end date
   * @param limit    data limit
   */
  getAgentAssignedLeads(
    from: string,
    to: string,
    campaignId: string,
    limit: Number,
    Skip: Number,
    fields: string,
    fieldValues: string,
    criteria: string
  ) {
    const url = `/lead/assignedLeads?StartDate=${from}&EndDate=${to}&CampaignId=${campaignId}&Limit=${limit}&Skip=${Skip}&Fields=${fields}&FieldValues=${fieldValues}&Criteria=${criteria}`;
    return this.httpClient.get(url).pipe(
      map((data: any) => {
        return {
          totalCount: data.TotalCount,
          calls: data.AssignedLeadsData.map((d: any) => {
            return {
              f_name: isNullUndefinedEmpty(d.Data.FirstName),
              l_name: isNullUndefinedEmpty(d.Data.LastName),
              phoneNumber: isNullUndefinedEmpty(d.PhoneNumber),
              callbackNumber: isNullUndefinedEmpty(d.PhoneNumber),
              call_campaign: {
                Id: d.Campaign.Id,
                Name: d.Campaign.Name,
                Code: d.Campaign.Code,
                //! To DO ??
                LanguageCode: '',
              },
              //! To DO ??
              tfn: '',
              disposition: isNullUndefinedEmpty(d.FinalDisposition),
              countryCode: isNullUndefinedEmpty(d.CountryCode),
              skill: isNullUndefinedEmpty(d.Campaign.Name),
              campaign: isNullUndefinedEmpty(d.Campaign.Code),
              lastAssignedOn: isNullUndefinedEmpty(moment(d.LastAssignedOn).format('DD-MMM-YY')),
              lastDialedOn: isNullUndefinedEmpty(moment(d.LastDialedOn).format('DD-MMM-YY')),
              nextDialedOn: isNullUndefinedEmpty(moment(d.DialDate).format('DD-MMM-YY')),
              nextFlowId: d.NextFlowId,
              dialCount: d.DialCount,
              payload: d.Data.Payload,
              lead_source: d.LeadSource,
              id: d.Id,
              scrub_disposition: d.ScrubDisposition,
              dial_count: d.DialCount
            };
          }),
        };
      })
    );
  }

  async getLead(campaignId: string, phone: string, email: string, leadId: string, direction: number) {
    const url = `${Constants.OUTBOUND_DIALER.GET_LEAD}/${campaignId}?phoneNumber=${encodeURIComponent(
      phone
    )}&email=${email}&leadId=${leadId}&direction=${direction}`;
    const lead = await lastValueFrom(this.httpClient.get(url));
    return lead;
  }
}
